import { MEMBERSHIP_USER_ACCESS_LEVEL } from 'src/features/membership/types';
import { z } from 'zod';

export type MembershipCloudUserFormSchemaValues = z.infer<typeof membershipCloudUserFormSchema>;
export const membershipCloudUserFormSchema = z.object({
    access_level: z.enum(MEMBERSHIP_USER_ACCESS_LEVEL),
    email: z.email().nonempty(),
});

export type MembershipCloudUserEditFormSchemaValues = z.infer<typeof membershipCloudUserEditFormSchema>;
export const membershipCloudUserEditFormSchema = z.object({
    access_level: z.enum(MEMBERSHIP_USER_ACCESS_LEVEL),
});
